const EmptyState = () => (
    <div className="text-center py-12 bg-gray-50 rounded-lg">
        <p className="text-gray-500 text-lg">
            Категории пока не добавлены
        </p>
    </div>
);

export default EmptyState;